var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _ from 'lodash';
import VueDialog from "../../../interface/IVueDialog";
import GoodService from '../../../api/GoodService';
import LicenseService from '../../../api/LicenseService';
import CommonService from '../../../api/CommonService';
import GLOBAL_VUE from '../../../globalVue';
import ArticleList from "../../../components/alert/ArticleList.vue";
import SeeBindLicenses from '../SeeBindLicenses';
import ArtMsglist from "../../../components/alert/ArtMsglist.vue";
import AddLicenses from '../components/addLicensesCol2/AddLicenses';
var CategoryDialog = (function (_super) {
    __extends(CategoryDialog, _super);
    function CategoryDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.goods = {};
        _this.selectRows = [];
        _this.Root_PageAuth$$ = {};
        _this.openedCodeData$$ = {};
        _this.stdList = [];
        return _this;
    }
    CategoryDialog.prototype.created = function () {
        this.service = GoodService.getInstance();
        this.commonService = CommonService.getInstance();
        this.licenseService = LicenseService.getInstance();
        this.getStd();
        this.getCategory();
    };
    CategoryDialog.prototype.getCategory = function () {
        var _this = this;
        this.service.getGoodFormatList({
            goods_id: this.goods_id
        }).then(function (res) {
            _this.listData = res.data.data.list || [];
            _this.goods = res.data.data.goods || {};
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    CategoryDialog.prototype.add = function () {
        this.listData.push({
            category_name: '',
            sort: '',
            isEdit: true
        });
    };
    CategoryDialog.prototype.saveCategory = function (index, row) {
        var _this = this;
        if (!row.sales_unit_coefficient || !(/^\d+(\.\d+)?$/.test(row.sales_unit_coefficient))) {
            this.$message.error("请填写正确的销售系数！");
            return;
        }
        var params = _.extend(row, { goods_id: this.goods_id });
        delete params.edit;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.saveGoodsFormat(params).then(function (res) {
            loadingInstance.close();
            if (res.data.code == 0) {
                _this.getCategory();
                _this.$message.success("保存成功");
                GLOBAL_VUE.$set(_this.listData[index], 'isEdit', false);
                return;
            }
            var instance = _this.$dialog(ArticleList, {
                data: {
                    resData: res.data,
                    modelType: 'specAndGood',
                    sureButtonText: res.data.code == 12 ? "确定" : '知道了'
                }
            }, {
                title: "提示",
                width: 450,
                height: 350,
                closeBtn: false,
            }).instance;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    CategoryDialog.prototype.editCategory = function (index) {
        GLOBAL_VUE.$set(this.listData[index], 'isEdit', true);
    };
    CategoryDialog.prototype.deleteCategory = function (index, goods_format_id, doFlag) {
        var _this = this;
        if (doFlag === void 0) { doFlag = 0; }
        if (!goods_format_id) {
            this.listData.splice(index, 1);
            return;
        }
        if (goods_format_id) {
            var params_1 = { goods_format_id: goods_format_id, do: doFlag };
            var loadingInstance_1 = Loading.service({ fullscreen: true });
            this.service.deleteGoodsFormat(params_1).then(function (res) {
                loadingInstance_1.close();
                if (res.data.code == 0) {
                    _this.getCategory();
                    _this.$message.success("删除成功");
                    return;
                }
                var instance = _this.$dialog(ArticleList, {
                    data: {
                        resData: res.data,
                        modelType: 'specAndGood',
                        sureButtonText: res.data.code == 12 ? "确定" : '知道了',
                        showCancelButton: res.data.code == 12
                    }
                }, {
                    title: "提示",
                    width: 450,
                    height: 350,
                    closeBtn: false,
                }).instance;
                instance.$on("addClient:ok", function (data) {
                    if (res.data.code == 12) {
                        var confirmStr = res.data.data.confirm;
                        var delParams = Object.assign({}, params_1, {
                            confirm: confirmStr
                        });
                        var loadingInstance_2 = Loading.service({ fullscreen: true });
                        _this.service.deleteGoodsFormat(delParams).then(function (res) {
                            loadingInstance_2.close();
                            if (res.data.code == 0) {
                                _this.getCategory();
                                _this.$message.success("删除成功");
                                return;
                            }
                            var instance = _this.$dialog(ArticleList, {
                                data: {
                                    resData: res.data,
                                    modelType: 'specAndGood',
                                    sureButtonText: res.data.code == 12 ? "确定" : '知道了'
                                }
                            }, {
                                title: "提示",
                                width: 450,
                                height: 350,
                                closeBtn: false,
                            }).instance;
                        });
                    }
                });
            }).catch(function (err) {
                loadingInstance_1.close();
                _this.$message.error(err.message || err.msg);
            });
        }
    };
    CategoryDialog.prototype.getStd = function () {
        var _this = this;
        this.service.getUnit().then(function (res) {
            if (res.data.success) {
                _this.stdList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    CategoryDialog.prototype.close = function () {
        this.$closeDialog();
    };
    CategoryDialog.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    CategoryDialog.prototype.bindLicenses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var goods_format_ids, loadingInstance, addedDatas, dialog;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.selectRows.length) {
                            this.$message.error('请先选择规格！');
                            return [2];
                        }
                        goods_format_ids = this.selectRows.map(function (v) { return v.goods_format_id; });
                        loadingInstance = Loading.service({ fullscreen: true });
                        return [4, this.getAlreadyBindLicenses(goods_format_ids)];
                    case 1:
                        addedDatas = _a.sent();
                        loadingInstance.close();
                        dialog = this.$dialog(AddLicenses, {
                            data: {
                                addedDatas: addedDatas
                            }
                        }, {
                            title: "绑定证照",
                            width: 950,
                            height: 500
                        });
                        dialog.instance.$on("save:ok", function (res) {
                            if (res.length == 0) {
                                _this.$message.warning('请至少选择一个证照');
                                return;
                            }
                            var document_ids = res.map(function (v) { return v.document_id; });
                            var params = {
                                goods_ids: _this.goods_id,
                                goods_format_ids: goods_format_ids.join(','),
                                document_ids: document_ids.join(',')
                            };
                            _this.bindLicensesAjax(params, dialog);
                        });
                        return [2];
                }
            });
        });
    };
    CategoryDialog.prototype.bindLicensesAjax = function (params, dialog) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.goodBindLicenses(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                if (res.data.code == 46) {
                    var instance = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                        }
                    }, {
                        title: "提示",
                        width: 450,
                        height: 350
                    }).instance;
                    instance.$on("artMsglist:ok", function (data) {
                        var confirm = res.data.data[0].confirm;
                        _this.bindLicensesAjax(__assign({}, params, { confirm: confirm }), dialog);
                    });
                }
                else {
                    _this.$message.success('绑定证照成功!');
                    dialog.instance.close();
                    _this.getCategory();
                }
            }
            else {
                loadingInstance.close();
                _this.$message.error(res.data.msg);
            }
            window._czc.push(["_trackEvent", '货品列表', '绑定证照']);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    CategoryDialog.prototype.getAlreadyBindLicenses = function (goods_format_ids) {
        return __awaiter(this, void 0, void 0, function () {
            var result, params;
            var _this = this;
            return __generator(this, function (_a) {
                result = [];
                params = {};
                Object.assign(params, {
                    goods_ids: this.goods_id,
                    goods_format_ids: goods_format_ids.join(',')
                });
                return [2, this.service.getGoodAlreadyBindLicensesIds(params).then(function (res) {
                        var document_ids = [];
                        if (res.data.success) {
                            document_ids = res.data.data.document_ids || [];
                        }
                        else {
                            _this.$message.error(res.data.msg);
                        }
                        return document_ids;
                    }).then(function (document_ids) {
                        if (document_ids.length > 0) {
                            var params_2 = {
                                page: 1,
                                start: 0,
                                limit: 2000
                            };
                            Object.assign(params_2, {
                                in_document_ids: (document_ids || []).join(',')
                            });
                            return _this.licenseService.getLicenseList(params_2).then(function (res) {
                                if (res.data.success) {
                                    result = res.data.data;
                                }
                                return result;
                            });
                        }
                        else {
                            return [];
                        }
                    }).catch(function () {
                        return result;
                    })];
            });
        });
    };
    CategoryDialog.prototype.seeBindLicenses = function (row) {
        GLOBAL_VUE.$emit('addTab', {
            component: SeeBindLicenses,
            opener: this,
            title: '查看绑定证照',
            showExist: true,
            name: 'goods-see-bind-license' + row.goods_id + 'goods_format_id' + row.goods_format_id,
            cprops: {
                goods_id: row.goods_id,
                goods_code: this.goods_code,
                goods_name: this.goods.goods_name,
                goods_format_id: row.goods_format_id,
                goods_format_name: row.goods_format_name
            }
        });
        this.close();
    };
    CategoryDialog = __decorate([
        Component
    ], CategoryDialog);
    return CategoryDialog;
}(VueDialog));
export default CategoryDialog;
